// src/hooks/useWeatherPrefs.js
// Live Map weather overlay preferences (precipitation / clouds / temp / wind / off).
// MODULE-scope shared state: consumed by MapLayersControl (writer), MapView
// (tile visibility), WeatherChip and WeatherPanel (data visibility).
import { useEffect, useReducer } from 'react';

const STORAGE_KEY = 'trackizy_livemap_weather';
const DEFAULTS = { tileLayer: 'off' };
const VALID_LAYERS = ['off', 'precipitation', 'clouds', 'temp', 'wind'];

function load() {
  try {
    const parsed = { ...DEFAULTS, ...JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}') };
    // Guard against a stale/hand-edited/corrupted localStorage value naming a
    // layer that no longer exists — fall back to 'off' rather than passing
    // an invalid layer through to the tile URL builder.
    if (!VALID_LAYERS.includes(parsed.tileLayer)) parsed.tileLayer = 'off';
    return parsed;
  } catch {
    return { ...DEFAULTS };
  }
}

let state = load();
const listeners = new Set();
const notify = () => listeners.forEach((l) => l());

export function setTileLayer(v) {
  const layer = VALID_LAYERS.includes(v) ? v : 'off';
  state = { ...state, tileLayer: layer };
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch { /* ignore */ }
  notify();
}

export function getWeatherPrefs() {
  return state;
}

export default function useWeatherPrefs() {
  const [, force] = useReducer((n) => n + 1, 0);
  useEffect(() => {
    listeners.add(force);
    return () => listeners.delete(force);
  }, []);
  return { tileLayer: state.tileLayer, setTileLayer };
}
